<template>
    <div class="mobParentalCon">
        <div class="costContainer" v-loading="loading">
            <div class="main">
                <div class="identity-header">
                    <h2>身份信息</h2>
                </div>
                <div class="identity-details">
                    <div class="detail-item">
                        <label>工号:</label>
                        <span>{{ employeeInfo.employeeId }}</span>
                    </div>
                    <div class="detail-item">
                        <label>姓名:</label>
                        <span>{{ employeeInfo.name }}</span>
                    </div>
                    <div class="detail-item">
                        <label>过期日期:</label>
                        <span>{{ employeeInfo.expiryDate }}</span>
                    </div>
                </div>
                <button class="modify-button" @click="modifyInfo">去更新</button>
            </div>
        </div>
    </div>

</template>

<script>
// import apis from "@/apis/insurance.js";
import api from "@/apis";
import moment from "moment";
import apiLogin from "@/apis";
import "moment/locale/zh-cn";
import { getToken } from "@/utils/cookie";
export default {

    name: "idcardEditPage",
    mounted() {
        this.loadUpdState();
    },
    data() {
        return {
            loading: false,
            checkIfUpd: false,
            employeeInfo: {
                employeeId: '1000001022',
                name: '小米',
                expiryDate: '2025-02-10',
            },
            parentDays: {
                balance: "--",
                effexpirationdate: "--"
            },
        }
    },
    methods: {
        modifyInfo() {
            this.$router.push('/mobile/idcard/edit');
        },
        loadUpdState() {
            const self = this;
            self.checkIfUpd = true;
        },
    },

}

</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
    .costContainer {
        width: 100%;
    }
}

@media screen and (min-width: 600px) {
    .costContainer {
        width: 276px * $zoom;
    }
}

.mobParentalCon {
    width: 100%;
    display: flex;
    justify-content: center;
    height: 100vh;
}

::v-deep {
    .el-table .cell.el-tooltip {
        width: 100% !important;
    }
}

.main {
    display: flex;
    flex-direction: column;
    padding: 0 30px;
    font-size: 24px;

    background: linear-gradient(#7fd1b3 0%, #fff 100%);
    /* 青绿色背景 */
    padding: 20px;
    border-radius: 8px;
    width: 100%;
    margin: 0 auto;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    height: 100vh;

    .identity-header {
        text-align: center;
        margin-bottom: 20px;

        h2 {
            font-size: 24px;
            color: white;
        }
    }

    .identity-details {
        margin-bottom: 20px;

        .detail-item {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            font-size: 26px;

            label {
                font-weight: bold;
                color: white;
            }

            span {
                color: #fff;
            }
        }
    }

    .modify-button {
        display: block;
        width: 100%;
        padding: 10px;
        background-color: #4db8a2;
        /* 深青绿色 */
        color: white;
        font-size: 30px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        text-align: center;

        &:hover {
            background-color: #3b8d74;
        }
    }

}
</style>